import React from 'react';
import {APP_VERSION} from 'shared/variables';

const About = () => (
  <div>
    <p>{APP_VERSION}</p>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/features/about/About.jsx